export default __webpack_public_path__ + "static/media/add-bill-icon.7bb31c52.svg";